import { Autocomplete, Box, TextField } from '@mui/material';
import { useGetStudysetSummaryById } from 'hooks';
import { StudyReturn } from 'neurostore-typescript-sdk';
import { useProjectExtractionStudysetId } from 'stores/projects/ProjectStore';
import { useMemo } from 'react';

const ExtractionTableJournalAutocomplete = ({  value, onChange  }: {
    value: string;
    onChange: (value: string | null) => void;
}) => {
    const studysetId = useProjectExtractionStudysetId();
    const { data: studyset } = useGetStudysetSummaryById(studysetId);

    const options = useMemo(() => {
        if (!studyset?.studies) return [];
        const journalsSet = new Set<string>();
        studyset.studies?.forEach((study) => {
            if ((study as StudyReturn)?.publication) {
                journalsSet.add((study as StudyReturn)?.publication || '');
            }
        });

        return Array.from(journalsSet).sort();
    }, [studyset]);

    const handleChange = (event: any, value: string | null) => {
        onChange(value);
    };

    return (
        <Box sx={{ marginTop: '4px' }}>
            <Autocomplete
                size="small"
                renderInput={(params) => <TextField {...params} placeholder="filter" />}
                onChange={handleChange}
                value={value || null}
                options={options}
            />
        </Box>
    );
};

export default ExtractionTableJournalAutocomplete;
